import Divider from '@eversports/klimt-primitives/legacy/Divider'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import SectionWrapper from '../../components/SectionWrapper'
import { Contact } from '../../VenueProfile.types'

import ContactIcons from './ContactIcons'
import CorporateDisclaimer from './CorporateDisclaimer'
import { SubscribeToNewsletter } from './SubscribeToNewsletter'

interface Props {
  contact: Contact
  venueId: string
  venueName: string
}

const ContactInformation = ({ contact, venueId, venueName }: Props) => {
  return (
    <SectionWrapper sx={{ p: 4 }}>
      <Stack gap={4}>
        <ContactIcons contact={contact} />
        <Divider sx={{ borderColor: 'lightgray' }} />
        <SubscribeToNewsletter venueId={venueId} venueName={venueName} />
        <CorporateDisclaimer />
      </Stack>
    </SectionWrapper>
  )
}

export default ContactInformation
